import React, { useState } from 'react'
import { Empty } from 'antd'
import _ from 'lodash'
import moment from 'moment'
import MaterialCodeModal from './MaterialCodeModal'

const MaterialCodeTable = (props) => {
    const { data, reload } = props
    const [isOpen, setIsOpen] = useState(false)
    const [materialId, setMaterialId] = useState(false)

    const handleOpenEdit = (id) => {
        setIsOpen(true)
        setMaterialId(id)
    }

    return (
        <table className="material-code-table table table-striped">
            <thead className="TableHead">
                <tr>
                    <th className='name'>Material Code</th>
                    <th className='min_stock'>Min Stock</th>
                    <th className='created_at'>Created at</th>
                    <th className='updated_by'>Updated by</th>
                    <th className='action'>Action</th>
                </tr>
            </thead>
            <tbody>
                {data && data.length > 0 ? data.map(i => (
                    <tr className='material-code-row' key={i._id}>
                        <td className='name'>{_.get(i, 'name') || '-'}</td>
                        <td className='min_stock'>{_.get(i, 'min_stock') || '-'}</td>
                        <td className='created_at'>{moment(_.get(i, 'created')).format("HH:mm DD/MM/YYYY") || '-'}</td>
                        <td className='updated_by'>{moment(_.get(i, 'updated')).format("HH:mm DD/MM/YYYY") || moment(_.get(i, 'created')).format("HH:mm DD/MM/YYYY")}</td>
                        <td
                            className='text-center cursor-pointer text-primary'
                            onClick={() => handleOpenEdit(i._id)}
                        >
                            Edit
                        </td>
                        <MaterialCodeModal
                            data={i}
                            isOpen={isOpen && materialId === i._id}
                            onClose={() => setIsOpen(false)}
                            title="Edit Material Code"
                            reload={reload}
                        />
                    </tr>
                )) :
                    <tr>
                        <td colSpan={5}><Empty /></td>
                    </tr>
                }
            </tbody>
        </table>
    )
}

export default MaterialCodeTable